export type AdvancedSlashSearchCommand = {
  aliases: readonly string[];
  id: string;
  type: string;
};

export function normalizeAdvancedSlashSearchText(value: string): string {
  return value
    .trim()
    .toLowerCase()
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .replace(/\s+/g, " ");
}

export function advancedSlashFuzzyIncludes(
  candidate: string,
  query: string,
): boolean {
  if (query === "") {
    return true;
  }

  let candidateIndex = 0;

  for (const queryCharacter of query) {
    candidateIndex = candidate.indexOf(queryCharacter, candidateIndex);

    if (candidateIndex === -1) {
      return false;
    }

    candidateIndex += 1;
  }

  return true;
}

export function advancedSlashCommandCandidateScore(
  command: AdvancedSlashSearchCommand,
  query: string,
  label: string,
  description: string,
): number | null {
  const normalizedQuery = normalizeAdvancedSlashSearchText(query);

  if (normalizedQuery === "") {
    return 0;
  }

  const exactAliasMatch = command.aliases
    .map(normalizeAdvancedSlashSearchText)
    .includes(normalizedQuery);

  if (exactAliasMatch) {
    return -2;
  }

  if (
    normalizeAdvancedSlashSearchText(command.id) === normalizedQuery
    || normalizeAdvancedSlashSearchText(command.type) === normalizedQuery
  ) {
    return -1;
  }

  const candidates = [
    command.id,
    command.type,
    ...command.aliases,
    label,
    description,
  ].map(normalizeAdvancedSlashSearchText);
  let bestScore: number | null = null;

  for (const candidate of candidates) {
    const score = candidate === normalizedQuery
      ? 0
      : candidate.startsWith(normalizedQuery)
        ? 1
        : candidate.split(" ").some((word) => word.startsWith(normalizedQuery))
          ? 2
          : candidate.includes(normalizedQuery)
            ? 3
            : advancedSlashFuzzyIncludes(candidate, normalizedQuery)
              ? 4 + (candidate.length / 100)
              : null;

    if (score !== null && (bestScore === null || score < bestScore)) {
      bestScore = score;
    }
  }

  return bestScore;
}
